export default __webpack_public_path__ + "static/media/office.609f85c3.png";